var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.headline,{tag:"component",staticClass:"ametras-headline-field"},[_c('span',{class:_vm.textColor},[_vm._v(_vm._s(_vm.label))]),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }